/**
 * Копирует подключённые стили из документа-источника в документ окна Document PiP,
 * чтобы портал с React-разметкой выглядел так же, как в основной вкладке.
 */
export function copyDocumentStyles(sourceDoc: Document, targetDoc: Document): void {
    const { head } = targetDoc;

    for (const styleSheet of Array.from(sourceDoc.styleSheets)) {
        try {
            const rules = Array.from(styleSheet.cssRules)
                .map((rule) => rule.cssText)
                .join('\n');
            const style = targetDoc.createElement('style');
            style.textContent = rules;
            head.appendChild(style);
        } catch {
            if (styleSheet.href) {
                const link = targetDoc.createElement('link');
                link.rel = 'stylesheet';
                link.href = styleSheet.href;
                head.appendChild(link);
            }
        }
    }
}
